import PropTypes from 'prop-types'
import { Box, Button, Chip } from '@material-ui/core'
import PerfectScrollbar from 'react-perfect-scrollbar'
import clsx from 'clsx'
import { reverse } from 'named-urls'
import { useHistory } from 'react-router-dom'

import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from 'components/Table'
import { MenuButton, Permitted } from 'components'

import constants from 'constants/index'
import { routes } from 'Routes'
import useStyles from './styles'

const RegulationsTable = ({ regulations = [], onChangeStatus = () => {} }) => {
  const { PLATFORMS, STATUSES, PLATFORM_LABEL, STATUS_LABEL } =
    constants.regulations
  const { REGULATIONS } = constants.permissions

  const classes = useStyles()
  const history = useHistory()

  const handleShow = (regulationId) =>
    history.push(reverse(routes.regulations.show, { regulationId }))

  const handleEdit = (regulationId) =>
    history.push(reverse(routes.regulations.edit, { regulationId }))

  const PLATFORM_CLASS = {
    [PLATFORMS.DPONET]: classes.dponet,
    [PLATFORMS.DPO_EASY]: classes.dpoEasy,
    [PLATFORMS.ADVISOR]: classes.advisor,
  }

  const STATUS_CLASS = {
    [STATUSES.ACTIVE]: classes.active,
    [STATUSES.INACTIVE]: classes.inactive,
    [STATUSES.DRAFT]: classes.draft,
  }

  return (
    <Box width="100%">
      <PerfectScrollbar
        options={{ wheelPropagation: false, useBothWheelAxes: true }}
      >
        <Table emptyMessage="Nenhum regulamento encontrado" noWrap>
          <TableHead>
            <TableRow>
              <TableCell width="10%">ID</TableCell>
              <TableCell width="50%" align="left">
                Título
              </TableCell>
              <TableCell width="20%" align="left">
                Plataforma
              </TableCell>
              <TableCell width="10%" align="left">
                Status
              </TableCell>
              <TableCell width="10%" align="right">
                Ações
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {regulations?.map((regulation) => {
              const isInactive = regulation?.status === STATUSES.INACTIVE

              return (
                <TableRow key={regulation?.id} hover>
                  <TableCell>{regulation?.id}</TableCell>
                  <TableCell width="50%" overFlowSize="100%">
                    {regulation?.title}
                  </TableCell>
                  <TableCell disableTooltip>
                    <Chip
                      className={clsx(
                        classes.chip,
                        PLATFORM_CLASS[regulation?.platform],
                      )}
                      size="small"
                      label={
                        PLATFORM_LABEL[regulation?.platform] || 'Indefinido'
                      }
                    />
                  </TableCell>
                  <TableCell disableTooltip>
                    <Chip
                      className={clsx(
                        classes.chip,
                        STATUS_CLASS[regulation?.status],
                      )}
                      size="small"
                      label={STATUS_LABEL[regulation?.status] || 'Indefinido'}
                    />
                  </TableCell>
                  <TableCell disableTooltip align="right">
                    <MenuButton>
                      <Button
                        fullWidth
                        size="small"
                        onClick={() => handleShow(regulation?.id)}
                      >
                        Visualizar
                      </Button>
                      <Permitted tag={REGULATIONS.MANAGE}>
                        <Button
                          fullWidth
                          size="small"
                          onClick={() => handleEdit(regulation?.id)}
                        >
                          Editar
                        </Button>
                        <Button
                          fullWidth
                          size="small"
                          onClick={() => onChangeStatus(regulation?.id)}
                        >
                          {isInactive ? 'Ativar' : 'Inativar'}
                        </Button>
                      </Permitted>
                    </MenuButton>
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </PerfectScrollbar>
    </Box>
  )
}

RegulationsTable.propTypes = {
  regulations: PropTypes.arrayOf(PropTypes.object),
  onChangeStatus: PropTypes.func,
}

export default RegulationsTable
